import { render, staticRenderFns } from "./TranshipmentCouriersView.vue?vue&type=template&id=6cb23cb0&scoped=true"
import script from "./TranshipmentCouriersView.vue?vue&type=script&lang=js"
export * from "./TranshipmentCouriersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb23cb0",
  null
  
)

export default component.exports